<h2 mat-dialog-title>
    {{ 'bookpage.dialog.header' | transloco }}
</h2>

<mat-dialog-content class="mat-typography content">
  <div class="books">
    @for (name of bookNames; track name) {
      <app-bookpage-list
        [bookpages]="books[name]"
        (openBookpage)="openBookpage($event)"
        (selectBookpage)="selectBookpage($event)"
        [selectedPage]="selectedBookpage"
      ></app-bookpage-list>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    [disabled]="selectedBookpage === null"
    (click)="openBookpage(selectedBookpage!)"
    >
        {{ 'slide-sync.bookpage-list-dialog.action-open' | transloco }}
    </button>
</mat-dialog-actions>

<button class="dialog-X-close" mat-icon-button (click)="closeDialog()">
  <mat-icon>close</mat-icon>
</button>
